import Label from 'LuxKit/Label'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

const FloatingBadge = styled.span`
  position: absolute;
  top: ${rem(-6)};
  left: ${rem(-6)};
  z-index: 1;
`

function CharterRewardGreatValueBadge() {
  const intl = useIntl()

  return <FloatingBadge>
    <Label kind="primary" variant="highlight-primary-dark">
      {intl.formatMessage({
        id: '8zOPfXDH3x0oJRFsXpeG',
        defaultMessage: 'Great value',
        description: 'Highlight pill on Maldives charter reward fare cards promoting reward-seat value',
      })}
    </Label>
  </FloatingBadge>
}

export default CharterRewardGreatValueBadge
